<div class="mt-50">
  <div class="help-center">
    <div class="row is-flex">
      <ng-container *ngIf="loading$ | async; else helpCenter">
        <ecp-loader *ngIf="loading$ | async" [fluid]="true"></ecp-loader>
      </ng-container>
      <ng-template #helpCenter>
        <div class="col is-flex is-fullwidth">
          <div class="container">
            <mat-tab-group>
              <mat-tab label="{{ (user$ | async)?.program.newsletterTitle }}">
                <ecp-newsletter></ecp-newsletter>
              </mat-tab>
              <mat-tab label="{{ (user$ | async)?.program.resourcesTitle }}">
                <ecp-resources></ecp-resources>
              </mat-tab>
              <mat-tab label="{{ (user$ | async)?.program.programOverviewTitle }}">
                <ecp-programs></ecp-programs>
              </mat-tab>
              <mat-tab label="{{ (user$ | async)?.program.tab4Title }}">
                <ecp-tab4></ecp-tab4>
              </mat-tab>
              <mat-tab label="{{ (user$ | async)?.program.tab5Title }}">
                <ecp-tab5></ecp-tab5>
              </mat-tab>
              <mat-tab label="{{ (user$ | async)?.program.tab6Title }}">
                <ecp-tab6></ecp-tab6>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
